angular.
module("dx.webapp.student").
controller("DxCreateStudentRouteController", function DxCreateStudentRouteController(
	$window,

	dxSession,
	NodeRepository
) {
	"use strict";

	var self = this;
	self.role = dxSession.getRole();
	self.disabledStudentCodes = true;

	NodeRepository.load(self.role.organizationId).then(function onNodeLoadSuccess(node) {
		self.disabledStudentCodes = node.disabledStudentCodes;
	});

	self.onCancel = function onCancel() {
		$window.history.back();
	};
});
